<template>
  <div class="section-main__warp work-order work-order-detail">
    <div class="header">
      <div class="flex-auto">
        <el-button style="float: left; padding: 7px 10px"
                   type="primary"
                   icon="iconfont icon-iconfontfanhui"
                   @click.stop="back()">{{ $t("workOrder.button.back") }}</el-button>
        <el-button type="primary"
                   style="padding: 7px 10px"
                   v-if="!isAdd"
                   icon="el-icon-view"
                   @click.stop="flow()">查看执行记录</el-button>
      </div>
      <div class="title flex-auto">{{ templateName }}</div>
      <div class="flex-auto"></div>
    </div>
    <div class="body">
      <div class="right-area mt10 flex">
        <div class="field-show pct50 mt20 flex"
             :class="[isAdd ? '' : 'edit']">
          <el-scrollbar class="scroll-bar">
            <div class="field-item detail"
                 v-for="(field, index) in fieldList"
                 :key="index">
              <el-row class="field-line">
                <el-col :span="4">
                  <div class="field-name col-height"
                       :class="{ required: field.required }">
                    <span>{{ field.fieldName }}：</span>
                  </div>
                </el-col>
                <el-col :span="16">
                  <div v-if="
                      (field.type === 1 && field.rowType === 1) ||
                      field.type === 2 ||
                      field.type === 3
                    "
                       class="flex-layout"
                       style="padding: 10px">
                    <!-- @change="((val)=>{field.search==1?inputSearch(val):''})" -->
                    <el-input style="color: #fff"
                              :type="field.numberType === 1 ? 'number' : 'text'"
                              :placeholder="field.placeholder"
                              @change="
                        (val) => {
                          field.search == 1
                            ? inputSearch(val, field, index)
                            : '';
                        }
                      "
                              v-model="field.fieldValue"
                              :disabled="!isAdd">
                      <template v-if="field.unitPosition === 1 && field.unit"
                                slot="prepend">{{ field.unit }}</template>
                      <template v-if="field.unitPosition === 2 && field.unit"
                                slot="append">
                        {{ field.unit }}
                      </template>
                    </el-input>
                  </div>
                  <div v-if="field.type === 1 && field.rowType === 2"
                       class="flex-layout">
                    <el-input type="textarea"
                              class="margin10"
                              :placeholder="field.placeholder"
                              v-model="field.fieldValue"
                              rows="5"
                              resize="none"
                              :disabled="!isAdd"></el-input>
                  </div>
                  <div v-else-if="field.type === 4">
                    <el-date-picker style="width: calc(100% - 20px)"
                                    class="margin10"
                                    :type="field.dateType === 1 ? 'date' : 'datetime'"
                                    :placeholder="
                        field.placeholder || '请选择' + field.fieldName
                      "
                                    :value-format="
                        field.dateType == 1
                          ? 'yyyy-MM-dd'
                          : 'yyyy-MM-dd HH:mm:ss'
                      "
                                    v-model="field.fieldValue"
                                    :disabled="!isAdd"></el-date-picker>
                  </div>
                  <div v-else-if="field.type === 5 && field.showType === 1"
                       class="flex-layout">
                    <el-select class="margin10"
                               style="flex: 1"
                               :disabled="!isAdd"
                               v-if="field.optionName"
                               v-model="field.fieldValue"
                               :multiple="field.selectType === 2"
                               :placeholder="
                        field.placeholder || '请选择' + field.fieldName
                      ">
                      <el-option v-for="(item, i) in field.valueList"
                                 :key="i"
                                 :label="item"
                                 :value="item"></el-option>
                    </el-select>
                  </div>
                  <div v-else-if="
                      field.type === 5 &&
                      field.showType === 2 &&
                      field.optionName
                    "
                       class="flex-layout">
                    <el-radio-group class="margin10"
                                    v-if="field.selectType === 1"
                                    v-model="field.fieldValue"
                                    :disabled="!isAdd">
                      <el-radio :label="item"
                                v-for="(item, i) in field.valueList"
                                :key="i"></el-radio>
                    </el-radio-group>
                    <el-checkbox-group class="margin10"
                                       :disabled="!isAdd"
                                       v-if="field.selectType === 2"
                                       v-model="field.fieldValue">
                      <el-checkbox :label="item"
                                   v-for="(item, i) in field.valueList"
                                   :key="i"></el-checkbox>
                    </el-checkbox-group>
                  </div>
                  <div v-else-if="field.type === 6">
                    <location class="margin10"
                              v-model="field.fieldValue"
                              :status="isAdd ? 'edit' : 'detail'"
                              :disabled="!isAdd"></location>
                  </div>
                  <div v-else-if="field.type === 7">
                    <!-- :file-list="pictureList" -->
                    <el-upload action
                               class="margin10"
                               :class="!isAdd ? 'hidePng' : ''"
                               ref="addRosterUl"
                               :file-list="field.uploadedList"
                               :show-file-list="true"
                               :list-type="'picture-card'"
                               :accept="'image/png, image/jpg, image/jpeg, image/bpm'"
                               :auto-upload="false"
                               :disabled="!isAdd"
                               :on-preview="showImg"
                               :on-change="
                        (file, fileList) => {
                          onChange(file, fileList, index);
                        }
                      "
                               :before-remove="beforeRemove"
                               :on-remove="
                        (file, fileList) => {
                          onRemove(file, fileList, index);
                        }
                      ">
                      <!-- :limit="1" -->
                      <i class="el-icon-plus"></i>
                    </el-upload>
                  </div>
                  <div v-else-if="field.type === 8">
                    <el-upload class="upload-demo margin10"
                               action="common/file/batchFileload.json"
                               :on-change="onChangeFile"
                               :on-remove="onRemoveFile"
                               :on-preview="onPreview"
                               :file-list="fileList"
                               :limit="1"
                               :disabled="!isAdd"
                               list-type="picture">
                      <el-button size="small"
                                 v-if="isAdd"
                                 type="primary">点击上传</el-button>
                    </el-upload>
                  </div>
                  <div v-else-if="field.type === 9">
                    <choose-area :placeholder="
                        field.placeholder || '请选择' + field.fieldName
                      "
                                 v-model="field.fieldValue"
                                 :disabled="!isAdd"></choose-area>
                  </div>
                  <div v-else-if="field.type === 10">
                    <choose-notice :placeholder="
                        field.placeholder || '请选择' + field.fieldName
                      "
                                   :disabled="!isAdd"
                                   v-model="field.fieldValue"></choose-notice>
                  </div>
                  <div v-else-if="field.type === 11">
                    <choose-Dpment :placeholder="
                        field.placeholder || '请选择' + field.fieldName
                      "
                                   v-model="field.fieldValue"
                                   :disabled="!isAdd"></choose-Dpment>
                  </div>
                  <div v-if="field.type === 12"
                       class="flex-layout">
                    <img :src="getImgPath(field.fieldValue)"
                         v-if="field.fieldValue"
                         @click="showViewer(getImgPath(field.fieldValue))"
                         onerror="this.src='/images/theme/newDark/default.png'"
                         style="
                        height: 40px;
                        width: 100px;
                        margin-left: 10px;
                        cursor: pointer;
                      " />
                  </div>
                </el-col>
              </el-row>
            </div>
            <!-- <div v-if="workOrderType!=5 && workOrderType!=2 && workOrderType!=3"> -->
            <div v-if="executorFlag == 1">
              <div class="field-item detail">
                <el-row class="field-line">
                  <el-col :span="4">
                    <div class="field-name col-height required">
                      <span>执行人员：</span>
                    </div>
                  </el-col>
                  <el-col :span="16">
                    <div class="field-value">
                      <choose-person :disabled="
                          !isAdd ||
                          (isAdd && $route.query.status ? true : false)
                        "
                                     :searchAble="true"
                                     v-model="personList"></choose-person>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div class="field-item detail">
                <el-row class="field-line">
                  <el-col :span="4">
                    <div class="field-name col-height required">
                      <span>时间期限：</span>
                    </div>
                  </el-col>
                  <el-col :span="16">
                    <div class="field-value">
                      <el-date-picker style="width: 100%"
                                      class="margin10"
                                      :type="'date'"
                                      v-model="endTime"
                                      :disabled="
                          !isAdd ||
                          (isAdd && $route.query.status ? true : false)
                        "
                                      placeholder="请选择执行工单截止时间"
                                      value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div class="field-item detail">
                <el-row class="field-line">
                  <el-col :span="4">
                    <div class="field-name col-height">
                      <span>超期前提醒：</span>
                    </div>
                  </el-col>
                  <el-col :span="16">
                    <div class="field-value flex-normal">
                      <el-radio-group class="margin10"
                                      :disabled="
                          !isAdd ||
                          (isAdd && $route.query.status ? true : false)
                        "
                                      v-model="sendBefore">
                        <el-radio :label="0">否</el-radio>
                        <el-radio :label="1">是</el-radio>
                      </el-radio-group>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div class="field-item detail"
                   v-if="sendBefore">
                <el-row class="field-line">
                  <el-col :span="4"> </el-col>
                  <el-col :span="16">
                    <field-notice class="margin10"
                                  :disabled="
                        !isAdd || (isAdd && $route.query.status ? true : false)
                      "
                                  title="超期前"
                                  v-model="promptBefore"
                                  :model-content="modelContent"
                                  :sms-messages="smsMessages.before"
                                  :app-messages="appMessages.before"></field-notice>
                  </el-col>
                </el-row>
              </div>
              <div class="field-item detail">
                <el-row class="field-line">
                  <el-col :span="4">
                    <div class="field-name col-height">
                      <span>超期后提醒：</span>
                    </div>
                  </el-col>
                  <el-col :span="16">
                    <div class="field-value flex-normal">
                      <el-radio-group class="margin10"
                                      :disabled="
                          !isAdd ||
                          (isAdd && $route.query.status ? true : false)
                        "
                                      v-model="sendAfter">
                        <el-radio :label="0">否</el-radio>
                        <el-radio :label="1">是</el-radio>
                      </el-radio-group>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div class="field-item detail"
                   v-if="sendAfter">
                <el-row class="field-line">
                  <el-col :span="4"> </el-col>
                  <el-col :span="16">
                    <field-notice class="margin10"
                                  title="超期后"
                                  :disabled="
                        !isAdd || (isAdd && $route.query.status ? true : false)
                      "
                                  v-model="promptAfter"
                                  :model-content="modelContent"
                                  :sms-messages="smsMessages.after"
                                  :app-messages="appMessages.after"></field-notice>
                  </el-col>
                </el-row>
              </div>
              <div class="field-item detail">
                <el-row class="field-line">
                  <el-col :span="4">
                    <div class="field-name content">
                      <span>执行人员签字：</span>
                    </div>
                  </el-col>
                  <el-col :span="16">
                    <div class="field-value flex-normal">
                      <el-radio-group :disabled="
                          !isAdd ||
                          (isAdd && $route.query.status ? true : false)
                        "
                                      class="margin10"
                                      v-model="excutorSignFlag">
                        <el-radio :label="0">不签字</el-radio>
                        <el-radio :label="1">签字</el-radio>
                      </el-radio-group>
                      <!-- <el-switch
                      class="margin10"
                      v-model="excutorSignFlag"
                    ></el-switch>
                    <span>{{ excutorSignFlag ? "签字" : "不签字" }}</span> -->
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div class="field-item detail"
                 v-if="workFlowFlag == 1">
              <el-row class="field-line">
                <el-col :span="4">
                  <div class="field-name col-height">
                    <span>审批人签字：</span>
                  </div>
                </el-col>
                <el-col :span="16">
                  <div class="field-value">
                    <el-select :disabled="
                        !isAdd || (isAdd && $route.query.status ? true : false)
                      "
                               class="margin10"
                               style="flex: 1"
                               v-model="processSigns"
                               multiple
                               placeholder="请选择需签字的审批人">
                      <el-option v-for="(item, index) in processList"
                                 :key="index"
                                 :label="item.name"
                                 :value="item.id"></el-option>
                    </el-select>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-scrollbar>
        </div>
        <!-- v-if="workOrderType!=5" -->
        <div>
          <div class="footer"
               v-if="isAdd">
            <el-button type="primary"
                       @click.stop="save()">{{
              $t("workOrder.button.save")
            }}</el-button>
            <el-button type="info"
                       @click.stop="cancel()">{{
              $t("workOrder.button.cancel")
            }}</el-button>
          </div>
          <div class="footer"
               v-if="!isAdd">
            <div>
              <div class="item">工单状态：{{ statusList[status] }}</div>
              <div class="item">
                <span>{{ templateCode }}</span>
                <span style="margin-left: 20px">{{ createTime }}</span>
              </div>
              <!-- 已结束的工单不展示操作按钮 -->
              <div class="item">
                <el-button type="primary"
                           @click.stop="examine()"
                           v-if="account.account === examineAccount && status < 3">去审批</el-button>
                <el-button type="primary"
                           @click.stop="finish()"
                           v-if="account.account === creator && status < 3">结束流程</el-button>
                <!-- <el-button type="primary"
                           @click.stop="flow()">查看执行记录</el-button> -->
              </div>
            </div>
          </div>
        </div>

        <el-dialog :width="'30%'"
                   :visible.sync="showExamine"
                   v-dialogDrag
                   title="完成节点任务"
                   :before-close="closeExamine">
          <el-form ref="examineForm"
                   :model="examineForm"
                   label-width="100px">
            <el-form-item prop="type"
                          label="审批">
              <el-radio class="margin10"
                        v-model="examineForm.type"
                        :label="0">同意</el-radio>
              <el-radio class="margin10"
                        v-model="examineForm.type"
                        :label="1">拒绝</el-radio>
            </el-form-item>
            <el-form-item label="审批描述">
              <el-input placeholder="请输入审批描述"
                        v-model="examineForm.desc"
                        type="textarea"
                        :autosize="{ minRows: 6 }"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer"
               class="dialog-footer">
            <el-button type="primary"
                       @click="saveExamine()">{{
              $t("workOrder.button.save")
            }}</el-button>
            <el-button type="info"
                       @click="closeExamine()">{{
              $t("workOrder.button.cancel")
            }}</el-button>
          </div>
        </el-dialog>
        <el-dialog :width="'30%'"
                   :visible.sync="showFlow"
                   v-dialogDrag
                   title="流程节点"
                   :before-close="closeFlow">
          <div>
            <el-timeline direction="vertical">
              <el-timeline-item v-for="(item, index) in workOrderFlowRecordList"
                                :key="index"
                                :type="
                  item.order < currentOrder
                    ? 'success'
                    : item.order === currentOrder
                    ? 'primary'
                    : 'info'
                "
                                :timestamp="item.operateTime">
                <div>
                  <span class="mr10 flow-type-label">{{
                    flowTypeList[item.type].label
                  }}</span>
                  <span class="flow-status"
                        :class="{
                      active: item.order < currentOrder,
                      current: item.order === currentOrder,
                    }">{{ item.nickName }}</span>
                </div>
                <div class="mt10 mb10 flow-status"
                     v-if="item.order <= currentOrder"
                     :class="{
                    active: item.order < currentOrder,
                    current: item.order === currentOrder,
                  }">
                  {{ flowTypeList[item.type].status[item.status] }}
                  <img v-if="item.fileCode"
                       :src="getImgPath(item.fileCode)"
                       @click="showViewer(getImgPath(item.fileCode))"
                       title="点击查看签名"
                       style="cursor:pointer;height: 25px; width: 50px; margin: 4px">
                </div>
              </el-timeline-item>
            </el-timeline>
            <div class="execute-detail-area"
                 v-if="status !== 1">
              <div class="detail-title">工单执行详情</div>
              <div v-for="(field, index) in executorList"
                   :key="index"
                   class="flex-between info-item">
                <div class="detail-field-name">{{ field.fieldName }}</div>
                <div v-if="field.type === 7"
                     class="info-value">
                  <div v-if="fileListimg.length"
                       style="
                      display: flex;
                      justify-content: flex-end;
                      flex-wrap: wrap;
                    ">
                    <img v-for="(item, imageIndex) in fileListimg"
                         :key="imageIndex"
                         :src="getImgPath(item)"
                         @click="showViewer(getImgPath(item))"
                         onerror="this.src='/images/theme/newDark/default.png'"
                         style="height: 25px; width: 50px; margin: 4px" />
                    <!-- <image class="field-img"
                           v-for="(item, imageIndex) in fileListimg"
                           :key="imageIndex"
                           :src="item"
                           mode="aspectFit"
                           @tap.stop="previewImage(item, imageIndex)">
                           </image> -->
                  </div>
                </div>
                <div v-else-if="field.type === 10"
                     class="info-value">
                  <span>{{ getNoticeStr(field.fieldValue) }}</span>
                </div>
                <div v-else
                     class="info-value">
                  <span class="unit-text-left"
                        v-if="field.unitPosition === 1 && field.unit">{{ field.unit }}</span>
                  <span>{{ getMmultipleText(field.fieldValue) }}</span>
                  <span class="unit-text-right"
                        v-if="field.unitPosition === 2 && field.unit">{{ field.unit }}</span>
                </div>
              </div>
            </div>
          </div>
          <div slot="footer"
               class="dialog-footer">
            <el-button type="info"
                       @click="closeFlow()">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
    <viewer @inited="inited"
            :images="viewerPhotos"
            class="viewer"
            ref="viewer">
      <img v-for="src in viewerPhotos"
           :src="src"
           :key="src" />
    </viewer>
  </div>
</template>

<script>
import { api } from "../api";
import { Cache } from "$utils";
import utils from "@src/common/utils";
import getData from "../option/fieldData";
// import ChoosePerson from "../components/choose-person";
import ChoosePerson from "../components/choose-people";
import ChooseArea from "../components/choose-area";
import ChooseDpment from "../components/choose-dpMent";
import ChooseNotice from "../components/choose-notice";
import fieldNotice from "../components/field-notice";
import location from "../components/location";
export default {
  components: {
    ChoosePerson,
    ChooseArea,
    location,
    ChooseNotice,
    fieldNotice,
    ChooseDpment,
  },
  data () {
    return {
      XfileUrl: Cache.get("SYS_FILEURL"),
      templateName: "",
      columnList: getData(),
      endTime: "",
      createTime: "",
      isAdd: true,
      status: "",
      showExamine: false,
      showFlow: false,
      examineForm: {},
      statusList: {
        1: "执行中",
        2: "审核中",
        3: "已结束",
        4: "已拒绝",
      },
      examineAccount: "", //审批人账号
      creator: "", //提单人账号
      fieldList: [],
      personList: [],
      workOrderFlowRecordList: [],
      fileList: [],
      fileListimg: [],
      pictureList: [],
      account: {},
      templateCode: "",
      flowTypeList: {
        1: {
          status: {
            1: "执行中",
            2: "已提交",
            3: "已拒绝",
          },
          label: "派单人",
        },
        2: {
          status: {
            1: "执行中",
            2: "已完成",
            3: "已拒绝",
          },
          label: "执行人",
        },
        3: {
          status: {
            1: "审批中",
            2: "已审批",
            3: "已拒绝",
          },
          label: "审批人",
        },
        99: {
          status: {
            1: "审批中",
            2: "已审批",
            3: "已拒绝",
            99: "结束",
          },
          label: "结束",
        },
      },
      picture: "",
      workOrderCode: "",
      excutorSignFlag: 0,
      processList: [],
      processSigns: [],
      modelContent: {},
      appMessages: {
        before: [],
        after: [],
      },
      smsMessages: {
        before: [],
        after: [],
      },
      sendBefore: 0,
      sendAfter: 0,
      promptBefore: {
        days: 1,
        sms: {
          checked: false,
          messageModel: "",
          messageContent: "",
        },
        appMsg: {
          checked: false,
          messageModel: "",
          messageContent: "",
        },
      },
      promptAfter: {
        days: 1,
        sms: {
          checked: false,
          messageModel: "",
          messageContent: "",
        },
        appMsg: {
          checked: false,
          messageModel: "",
          messageContent: "",
        },
      },
      activeFieldName: "submiter",
      currentOrder: 0,
      executorList: [],
      pageStatus: "edit",
      executorFlag: "",
      workFlowFlag: "",
      viewerInstance: null,
      viewerPhotos: [],
    };
  },
  created () {
    if (this.$route.query && this.$route.query.workOrderType) {
      this.workOrderType = this.$route.query.workOrderType;
      this.executorFlag = this.$route.query.executorFlag;
      this.workFlowFlag = this.$route.query.workFlowFlag;
    }
  },
  mounted () {
    if (this.$route.query && this.$route.query.templateCode) {
      this.templateCode = this.$route.query.templateCode;
    }
    if (this.$route.query && this.$route.query.templateName) {
      this.templateName = this.$route.query.templateName;
    }

    if (this.$route.query && this.$route.query.workOrderCode) {
      this.workOrderCode = this.$route.query.workOrderCode;
      if (!this.$route.query.status) {
        this.isAdd = false;
      }
      this.getDetail();
    } else {
      this.queryWorkOrderFieldList();
    }
    this.queryFlow();
    this.querySmsTemplate();
  },
  methods: {
    inputSearch (value, item, index) {
      console.log(this.fieldList);
      this.$fetch(api.workOrder.queryRelationWorkOrderDetail, {
        fieldCode: item.fieldCode,
        fieldValue: value,
        templateCode: this.templateCode,
      }).then((res) => {
        if (res && res.success) {
          let modelsList = res.returnObj && res.returnObj.workOrderList;
          if (modelsList && modelsList.length) {
            // 后台数据结构和前台相识，无需重新判断
            modelsList.forEach((el, index) => {
              if (el.type != 4 && el.type != 7) {
                // 多选回显
                if (el.type == 5 && this.fieldList[index].selectType == 2) {
                  this.fieldList[index].fieldValue = el.fieldValue
                    .split("|")
                    .map((el) => {
                      return el.split(":")[0];
                    });
                } else {
                  this.fieldList[index].fieldValue =
                    el.fieldValue.split(":")[0];
                }
                // 图片
                // if (el.type == 7 && el.flowType == 1) {
                //   this.picture = el.fieldValue;
                //   // 多张图片
                //   this.pictureList = []
                //   el.fieldValue ? el.fieldValue.split("|").map((img, index) => {
                //     this.pictureList.push({
                //       url: utils.Bus.imgPath(img),
                //       oldurl: img,
                //     })
                //   }) : ""
                // }
              }
            });
          }
          // console.log(this.fieldList);
        } else {
          this.$message.warning(res.msgContent);
        }
      });
    },
    showImg (item) {
      this.showViewer(item.url);
    },
    showViewer (src) {
      this.viewerPhotos = [src];
      src && this.viewerInstance.show();
    },
    inited (viewer) {
      this.viewerInstance = viewer;
    },
    getImgPath (item) {
      // 适配app端多张图片显示 默认显示第一张
      return item ? utils.Bus.imgPath(item) : "";
    },
    getNoticeStr (str) {
      return str
        ? (str + "")
          .split("|")
          .map((item) => {
            let name = item.split(":")[0];
            return (
              name.split("-")[0] +
              (name.split("-")[1] ? "(" + name.split("-")[1] + ")" : "")
            );
          })
          .join("、")
        : "";
    },
    getMmultipleText (str) {
      return str ? (str + "").split("|").join("、") : "";
    },
    changeModel (value, key, type) {
      this.promptOption[key][type].messageContent = this.modelContent[value];
    },
    // 查询短信模板
    querySmsTemplate () {
      // 消息通知类型与后台定义的消息类型对应配置
      let messageTypeMap = {
        // App信息通知，对应的后台消息类型为5
        app: 5,
        // 短信通知，对应的后台消息类型为3
        sms: 3,
        // 到期前通知，childServiceType = 3
        before: 3,
        // 超期后通知，childServiceType = 4
        after: 4,
      };
      // workOrderType 工单类型，1：巡检工单，2：超速罚单，3：车辆违规罚单，4：维修工单,5日常管理
      // type 类型，1：工单表格，2：工单
      this.modelContent = {};
      // serviceType 业务类型，1：罚单通知，2：预案通知，3：预约通知，4：自定义工单通知
      this.$fetch(api.workOrder.queryWorkOrderNoticeTemplate, {
        workOrderType: this.workOrderType,
        type: 2,
      }).then((response) => {
        if (response && response.success) {
          let modelsList = response.returnObj;
          if (modelsList && modelsList.length) {
            this.modelContent = {};
            modelsList.forEach((item) => {
              this.modelContent[item.noticeTemplateCode] = item.templateContent;
              if (
                item.templateType === messageTypeMap.app &&
                item.childServiceType === messageTypeMap.before
              ) {
                this.appMessages.before.push(item);
              } else if (
                item.templateType === messageTypeMap.app &&
                item.childServiceType === messageTypeMap.after
              ) {
                this.appMessages.after.push(item);
              } else if (
                item.templateType === messageTypeMap.sms &&
                item.childServiceType === messageTypeMap.before
              ) {
                this.smsMessages.before.push(item);
              } else if (
                item.templateType === messageTypeMap.sms &&
                item.childServiceType === messageTypeMap.after
              ) {
                this.smsMessages.after.push(item);
              }
            });
          }
        } else {
          this.$message.warning(response.msgContent);
        }
      });
    },
    queryFlow () {
      this.$fetch(api.workOrder.queryWorkOrderFlowList, {
        templateCode: this.templateCode,
      }).then((res) => {
        if (res.success) {
          if (res.returnObj && res.returnObj.length) {
            res.returnObj.forEach((item) => {
              this.processList.push({
                id: item.nodeCode,
                name: item.nodeName,
              });
            });
          }
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    queryWorkOrderFieldList () {
      this.$fetch(api.workOrder.queryWorkOrderFieldList, {
        // 流程类型，1：派单人，2：执行人
        flowType: 1,
        templateCode: this.templateCode,
      }).then((res) => {
        if (res.success) {
          this.fieldList = this.convertField(res.returnObj);
          // console.log(this.fieldList);
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    convertField (dataList = []) {
      let result = [];
      dataList.forEach((data) => {
        this.columnList.forEach((col) => {
          if (Number(data.type) === col.type) {
            let obj = utils.setFieldData({ ...col }, data);
            // 将字段类型保存起来，用于详情展示时区分提交人字段和执行人字段展示
            obj.flowType = data.flowType;
            result.push(obj);
          }
        });
      });
      return result;
    },
    getNotice (expireType) {
      let result = [];
      let promptData = expireType === 1 ? this.promptBefore : this.promptAfter;
      let promptTitle = expireType === 1 ? "超期前" : "超期后";
      if (!promptData.days) {
        this.$message.warning("请输入" + promptTitle + "提醒天数");
        return false;
      }
      if (!promptData.sms.checked && !promptData.appMsg.checked) {
        this.$message.warning(
          promptTitle + "提醒，短信通知和消息通知至少勾选一个"
        );
        return false;
      }
      if (promptData.sms.checked) {
        if (!promptData.sms.messageModel) {
          this.$message.warning("请选择" + promptTitle + "提醒的短信通知模板");
          return false;
        }
        result.push({
          // 通知类型，1：消息 2：短信
          noticeType: 2,
          // 消息模板编号
          noticeTemplateCode: promptData.sms.messageModel,
          // 是否发送，0：否 1：是
          isSend: 1,
          // 到期类型，1：到期前 2：到期后
          expireType: expireType,
          // 到期天数
          expireDays: promptData.days,
        });
      }
      if (promptData.appMsg.checked) {
        if (!promptData.appMsg.messageModel) {
          this.$message.warning("请选择" + promptTitle + "提醒的消息通知模板");
          return false;
        }
        result.push({
          // 通知类型，1：消息 2：短信
          noticeType: 1,
          // 消息模板编号
          noticeTemplateCode: promptData.appMsg.messageModel,
          // 是否发送，0：否 1：是
          isSend: 1,
          // 到期类型，1：到期前 2：到期后
          expireType: expireType,
          // 到期天数
          expireDays: promptData.days,
        });
      }
      return result;
    },
    getNoticeConfig () {
      let result = [];
      if (this.sendBefore) {
        let beforeResult = this.getNotice(1);
        if (!beforeResult) {
          return beforeResult;
        }
        result = result.concat(beforeResult);
      }
      if (this.sendAfter) {
        let afterResult = this.getNotice(2);
        if (!afterResult) {
          return afterResult;
        }
        result = result.concat(afterResult);
      }
      return result;
    },
    async save () {
      await this.uploadFile();
      await this.uploadPicture();
      const workOrderList = this.getFieldList();
      console.log("自定义字段信息为：", workOrderList);
      if (!workOrderList || !workOrderList.length) {
        this.$message.warning("数据校验失败，无法保存");
        console.log("数据校验失败，保存错误");
        return;
      }
      let workOrderNoticeConfigList = this.getNoticeConfig();
      if (!workOrderNoticeConfigList) {
        return;
      }
      let workOrderSignList = [];
      if (this.processSigns && this.processSigns.length) {
        this.processSigns.forEach((item) => {
          workOrderSignList.push({
            signFlag: 1,
            nodeCode: item,
          });
        });
      }
      let params = {};
      params = {
        workOrderNoticeConfigList: workOrderNoticeConfigList,
        templateCode: this.templateCode,
        endTime: this.endTime,
        workOrderPersonList: this.personList,
        workOrderList: workOrderList,
        excutorSignFlag: this.excutorSignFlag,
        workOrderSignList: workOrderSignList,
        workOrderType: this.workOrderType,
      };
      let url = api.workOrder.addWorkOrder;
      if (this.$route.query.status) {
        //编辑状态
        url = api.workOrder.fixWorkOrder;
        params = {
          flowType: 1,
          workOrderCode: this.workOrderCode,
          workOrderList: workOrderList,
        };
      }
      this.$fetch(url, params).then((res) => {
        if (res.success) {
          this.$message.success("操作成功");
          this.$router.go(-1);
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    cancel () {
      this.$router.go(-1);
    },
    onChange (file, fileList, index) {
      // file 新增的文件 fileList剩余的文件list
      // this.pictureList = fileList; //剩余的文件list
      this.fieldList[index].uploadedList = fileList; //剩余的文件list
      // this.$set(this.templateInfo, 'fileList', fileList)
      // console.log(this.fieldList)
    },
    beforeRemove (file, fileList) {
      console.log(file, "========file");
      if (
        (file && file.status === "ready") ||
        (file && file.status === "success")
      ) {
        return this.$confirm("确认删除该图片?", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          })
          .catch(() => {
            reject(false);
          });
      }
    },
    onRemove (file, fileList, index) {
      this.fieldList[index].uploadedList = fileList;

      // file 删除的文件 fileList剩余的文件list
      // this.picture = "";
      // this.pictureList = fileList; //剩余的文件list
      //剩余的文件list
      // this.$set(this.templateInfo, 'fileList', fileList)
      // console.log(this.fieldList)
    },
    onChangeFile (file, fileList) {
      this.fileList = fileList;
      // this.$set(this.templateInfo, 'fileList', fileList)
    },
    onRemoveFile (file, fileList) {
      this.fileCode = "";
      this.fileList = fileList;
      // this.$set(this.templateInfo, 'fileList', fileList)
    },
    onPreview (file) {
      // 下载附件
      if (this.isAdd) {
        window.location.href = this.XfileUrl + file.old;
      }
    },
    getFieldList () {
      let result = [];
      for (let i = 0; i < this.fieldList.length; i++) {
        const item = this.fieldList[i];
        let fieldCode = item.fieldCode;
        let fieldValue = item.fieldValue;
        // if (item.type === 7) {
        //   fieldValue = this.picture;
        // }
        if (item.type === 8) {
          fieldValue = this.fileCode;
        }
        // web端签名不必校验
        if (
          item.type !== 12 &&
          item.required &&
          !(
            fieldValue !== undefined &&
            fieldValue !== null &&
            fieldValue !== "" &&
            fieldValue !== [] &&
            fieldValue !== {}
          )
        ) {
          this.$message.error(item.fieldName + "不可为空");
          return null;
        }
        if (item.type === 5 && item.selectType === 2) {
          let newValue = [];
          fieldValue.forEach((el) => {
            let indexColor = item.valueList.indexOf(el);
            newValue.push(item.optionName.split("|")[indexColor]);
          });
          fieldValue = newValue.join("|");
        }
        if (item.type === 5 && item.selectType === 1) {
          let indexColor = item.valueList.indexOf(fieldValue);
          fieldValue = item.optionName.split("|")[indexColor];
        }
        // 空数据放开传给后台
        // if (
        //   fieldValue !== undefined &&
        //   fieldValue !== null &&
        //   fieldValue !== "" &&
        //   fieldValue !== [] &&
        //   fieldValue !== {}
        // ) {
        result.push({
          fieldCode: fieldCode,
          fieldValue: fieldValue,
        });
        // }
      }
      return result;
    },
    async uploadPicture () {
      // 上传图片
      return new Promise((resolve, reject) => {
        this.fieldList.forEach((fileItem, index) => {
          if (fileItem.uploadedList && fileItem.uploadedList.length) {
            // 有图片
            let formData = new FormData();
            let oldUrls = [];
            fileItem.uploadedList.map((item) => {
              // 新上传的文件
              if (item.status == "ready") {
                formData.append("files", item.raw);
              } else {
                oldUrls.push(item.oldurl);
              }
            });
            if (oldUrls.length == fileItem.uploadedList.length) {
              // this.picture = oldUrls.join("|");
              fileItem.fieldValue = oldUrls.join("|");
              return;
            }
            // this.picture = "";
            this.$fetch(api.workOrder.upFile, formData).then((res) => {
              if (res.success) {
                res.returnObj.forEach((item) => {
                  oldUrls.push(item.fileId);
                });
                // this.picture = oldUrls.join("|");
                fileItem.fieldValue = oldUrls.join("|");
                // resolve(fileItem.fieldValue);
              } else {
                this.$message.error(res.msgContent);
                // reject(res);
              }
            });
          } else {
            // resolve();
          }
        });
        setTimeout(() => {
          resolve();
        }, 1000);

        // if (this.pictureList.length === 0) {
        //   // 没有图片
        //   this.picture = "";
        //   resolve();
        // } else {
        //   // 有图片
        //   let formData = new FormData();
        //   let oldUrls = [];
        //   this.pictureList.map((item) => {
        //     // 新上传的文件
        //     if (item.status == "ready") {
        //       formData.append("files", item.raw);
        //     } else {
        //       oldUrls.push(item.oldurl);
        //     }
        //   });
        //   if (oldUrls.length == this.pictureList.length) {
        //     this.picture = oldUrls.join("|");
        //     resolve(this.picture);
        //     return;
        //   }
        //   this.picture = "";
        //   this.$fetch(api.workOrder.upFile, formData).then((res) => {
        //     if (res.success) {
        //       res.returnObj.forEach((item) => {
        //         oldUrls.push(item.fileId);
        //       });
        //       this.picture = oldUrls.join("|");
        //       resolve(this.picture);
        //     } else {
        //       this.$message.error(res.msgContent);
        //       reject(res);
        //     }
        //   });
        // }
      });
    },
    async uploadFile () {
      // 上传文件
      return new Promise((resolve, reject) => {
        if (this.fileList.length === 0 || this.fileCode) {
          resolve();
        } else {
          let formData = new FormData();
          this.fileList.map((item) => {
            formData.append("files", item.raw);
          });
          let picUrl = [];
          this.fileCode = "";
          this.$fetch(api.workOrder.upFile, formData).then((res) => {
            if (res.success) {
              res.returnObj.forEach((item) => {
                picUrl.push(item.fileId);
              });
              this.fileCode = picUrl.join(",");
              resolve(this.fileCode);
            } else {
              this.$message.error(res.msgContent);
              reject(res);
            }
          });
        }
      });
    },
    buildPromptOption (configList = []) {
      this.sendBefore = 0;
      this.sendAfter = 0;
      this.promptBefore = {
        days: 1,
        sms: {
          checked: false,
          messageModel: "",
          messageContent: "",
        },
        appMsg: {
          checked: false,
          messageModel: "",
          messageContent: "",
        },
      };
      this.promptAfter = {
        days: 1,
        sms: {
          checked: false,
          messageModel: "",
          messageContent: "",
        },
        appMsg: {
          checked: false,
          messageModel: "",
          messageContent: "",
        },
      };
      configList.forEach((item) => {
        // 如果有超期前（item.expireType === 1）的通知，则将超期前的提醒设置为“是”
        if (item.expireType === "1") {
          this.sendBefore = 1;
          this.promptBefore.days = item.expireDays;
          // noticeType 通知类型，1：短信 2：消息
          // 通知类型为短信通知，则设置短信通知对象
          if (item.noticeType === "2") {
            this.promptBefore.sms = {
              checked: true,
              messageModel: item.noticeTemplateCode,
              messageContent: item.templateContent,
            };
          } else if (item.noticeType === "1") {
            // 通知类型为消息通知，则设置消息通知对象
            this.promptBefore.appMsg = {
              checked: true,
              messageModel: item.noticeTemplateCode,
              messageContent: item.templateContent,
            };
          }
        } else if (item.expireType === "2") {
          // 如果有超期后（item.expireType === 2）的通知，则将超期后的提醒设置为“是”
          this.sendAfter = 1;
          this.promptAfter.days = item.expireDays;
          // noticeType 通知类型，1消息： 2：短信
          // 通知类型为短信通知，则设置短信通知对象
          if (item.noticeType === "2") {
            this.promptAfter.sms = {
              checked: true,
              messageModel: item.noticeTemplateCode,
              messageContent: item.templateContent,
            };
          } else if (item.noticeType === "1") {
            // 通知类型为消息通知，则设置消息通知对象
            this.promptAfter.appMsg = {
              checked: true,
              messageModel: item.noticeTemplateCode,
              messageContent: item.templateContent,
            };
          }
        }
      });
    },
    getDetail () {
      this.account = utils.Cache.get("CACHE_USER_INFO");
      this.$fetch(api.workOrder.queryWorkOrderDetail, {
        workOrderCode: this.workOrderCode,
      }).then((res) => {
        if (res.success) {
          this.workOrderList = res.returnObj.workOrderList;
          this.personList = res.returnObj.workOrderPersonList;
          // console.log(this.personList)
          this.buildPromptOption(res.returnObj.workOrderNoticeConfigList);
          // 查询所有自定义字段，包含执行字段
          this.$fetch(api.workOrder.queryWorkOrderFieldList, {
            templateCode: this.templateCode,
          }).then((resp) => {
            if (resp.success) {
              this.workOrderFlowRecordList =
                res.returnObj.workOrderFlowRecordList;
              let allFieldList = this.convertField(resp.returnObj);
              this.executorList = [];
              this.fieldList = [];
              allFieldList.forEach((field) => {
                this.workOrderList.forEach((data) => {
                  if (data.fieldCode === field.fieldCode) {
                    // 多选回显
                    if (field.type === 5 && field.selectType === 2) {
                      if (data.fieldValue.length) {
                        field.fieldValue = data.fieldValue
                          .split("|")
                          .map((el) => {
                            return el.split(":")[0];
                          });
                      }
                      field.colorValue = data.fieldValue
                        .split("|")
                        .map((el) => {
                          return el.split(":")[1];
                        });
                    } else {
                      field.fieldValue = data.fieldValue;
                    }
                    if (field.type === 5 && field.selectType === 1) {
                      field.fieldValue = field.fieldValue.split(":")[0];
                      field.colorValue = field.fieldValue.split(":")[1];
                    }
                    // 图片
                    if (field.type === 7 && field.flowType == 1) {
                      this.picture = data.fieldValue;
                      // 多张图片
                      // this.pictureList = [];
                      field.uploadedList = [];
                      data.fieldValue
                        ? data.fieldValue.split("|").map((el, index) => {
                          field.uploadedList.push({
                            url: utils.Bus.imgPath(el),
                            oldurl: el,
                          });
                          // this.pictureList.push({
                          //   url: utils.Bus.imgPath(el),
                          //   oldurl: el,
                          // });
                        })
                        : "";
                      // 单张图片
                      // data.fieldValue ?
                      //   this.pictureList = [
                      //     { url: utils.Bus.imgPath(data.fieldValue.split("|")[0]) },
                      //   ] : this.pictureList = [];
                    }
                    // 执行人
                    if (field.type === 7 && field.flowType == 2) {
                      data.fieldValue
                        ? (this.fileListimg = data.fieldValue.split("|"))
                        : (this.fileListimg = []);
                    }
                    // 附件
                    if (field.type === 8) {
                      this.fileCode = data.fieldValue;
                      data.fieldValue
                        ? (this.fileList = [
                          {
                            name: data.ofileName,
                            old: data.fieldValue,
                            url: utils.Bus.imgPath(data.fieldValue),
                          },
                        ])
                        : (this.fileList = []);
                    }
                  }
                });
                if (parseInt(field.flowType) === 2) {
                  this.executorList.push(field);
                } else {
                  this.fieldList.push(field);
                }
              });
              // console.log(this.fileListimg)
              this.$log.debug(
                "封装后的提交人自定义字段列表为：",
                this.fieldList
              );
              this.$log.debug(
                "封装后的执行人自定义字段列表为：",
                this.executorList
              );
              const currentFlowCode = this.workOrderList[0].currentFlowCode;
              this.status = this.workOrderList[0].status;
              this.createTime = this.workOrderList[0].createTime;
              this.creator = this.workOrderList[0].creator;
              this.endTime = this.workOrderList[0].endTime
                ? this.workOrderList[0].endTime
                : utils.Dates.format(new Date());
              res.returnObj.workOrderFlowRecordList.some((item) => {
                if (item.flowCode === currentFlowCode) {
                  this.flowCode = item.flowCode;
                  this.nodeCode = item.nodeCode;
                  this.currentOrder = item.order;
                  // return true;
                  if (item.type === 3) {
                    this.examineAccount = item.accountNumber;
                  }
                }
                if (item.type === 2) {
                  item.nickName = this.personList
                    .map((pItem) => {
                      return pItem.nickName;
                    })
                    .join("、");
                  this.excutorSignFlag = item.signFlag;
                } else if (item.type === 3 && item.signFlag === 1) {
                  this.processSigns.push(item.nodeCode);
                }
              });
            } else {
              this.$message.error(res.msgContent);
            }
          });
        } else {
          this.$message.error(res.msgContent);
        }
      });
      // console.log(this.fieldList);
    },
    back () {
      this.$router.go(-1);
    },
    examine () {
      this.showExamine = true;
    },
    finish () {
      this.$fetch(api.workOrder.updateWorkOrder, {
        workOrderCode: this.workOrderCode,
        status: 3,
        desc: "流程结束",
      }).then((res) => {
        if (res.success) {
          this.$message.success("流程已结束");
          this.getDetail();
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    flow () {
      this.showFlow = true;
    },
    closeExamine () {
      this.showExamine = false;
      this.examineForm = {};
      this.$refs.examineForm.resetFields();
    },
    saveExamine () {
      this.$refs.examineForm.validate((valid) => {
        if (valid) {
          this.$fetch(api.workOrder.approvalWorkOrder, {
            templateCode: this.templateCode,
            flowCode: this.flowCode,
            nodeCode: this.nodeCode,
            workOrderCode: this.workOrderCode,
            type: this.examineForm.type,
            desc: this.examineForm.desc,
          }).then((res) => {
            if (res.success) {
              this.$message.success("审批成功");
              this.closeExamine();
              this.getDetail();
            }
          });
        }
      });
    },
    closeFlow () {
      this.showFlow = false;
    },
  },
};
</script>

<style lang="scss">
@import "~@src/common/assets/style/mixin";

.el-upload--picture-card {
  // width: 107px;
  width: 23%;
  height: 110px;
  line-height: 110px;
}
.el-upload-list--picture-card .el-upload-list__item {
  // width: 107px !important;
  width: 23% !important;
  height: 110px !important;
  // height: 100% !important;
}
.hidePng {
  .el-upload--picture-card {
    display: none;
  }
}
.execute-detail-area {
  .detail-title {
    @include set_theme_color(color, font-default-color);
    font-size: 16px;
    margin: 10px 0 10px 0;
  }

  .info-item {
    padding: 8px 0;
    border-bottom: 1px solid;
    @include set_theme_color(border-color, top-menu-border-color);

    .info-value {
      @include set_theme_color(color, font-default-color);
    }
    .detail-field-name {
      background: rgba(255, 255, 255, 0.4);
      padding: 2px;
      margin-right: 20px;
    }
  }

  .unit-text-left {
    margin-right: 5px;
  }

  .unit-text-right {
    margin-left: 5px;
  }
}
</style>